/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetBusinessPossibleAppointmentsModel,
  IMappers,
  TGetBusinessPossibleAppointmentsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetBusinessPossibleAppointmentsResponse } from '../../entities/AnnouncementReferences/GetBusinessPossibleAppointmentsResponse';

export function createGetBusinessPossibleAppointmentsModel(): TGetBusinessPossibleAppointmentsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'announcements',
    pathApi: '/v1/get-business-possible-appointments/',
    response: {
      '200': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetBusinessPossibleAppointmentsOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchGetBusinessPossibleAppointments<TResponse200>({
  httpApi,
  config,
  mappers,
}: IGetBusinessPossibleAppointmentsOptions<TResponse200>): Promise<
  FetchResponse<TGetBusinessPossibleAppointmentsResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBusinessPossibleAppointmentsModel(),
    config,
  )) as FetchResponse<TGetBusinessPossibleAppointmentsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBusinessPossibleAppointmentsResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBusinessPossibleAppointmentsResponse>;
}
